<div
  class="section-anchor"
  [ngClass]="{ valid: touched && valid, error: touched && !valid }"
></div>
